import React, {useState, useEffect} from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Select from "react-select";
import ApiService from "../../util/ApiService";
import CustomPagination from "../../util/CustomPagination";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import Swal from "sweetalert2";
import {Col, Row} from "reactstrap";
import LoadingScreen from "../../util/LoadingScreen";
import Switch from "react-switch"; // Importando o JS do Bootstrap


const PreferencesPresenceAttendanceControlModal = ({show, onHide, preferences: initialPreferences = {}}) => {

    const [selectedDepartments, setSelectedDepartments] = useState([]); // Agora armazena múltiplos departamentos
    const [selectedLocals, setSelectedLocals] = useState([]); // Agora armazena múltiplos departamentos
    const [departments, setDepartments] = useState([]);
    const [locals, setLocals] = useState([]);
    const [loadingSearch, setLoadingSearch] = useState(false);

    const [preferences, setPreferences] = useState(
        {
            name: "",
            enabled: 0,
            enable_exit_on_sequential_duties: 0,
            enable_single_entry: 0,
            enable_facial_recognition: 0,
            enable_register_history: 0,
            enable_justify_time: 0,
            enable_register_status_view: 0,
            require_geolocation: 0,
            presence_permission_check_rt_limit: 0,
            presence_permission_check_rt: 0,
            show_checkin_button_before: "",
            show_checkout_button_after: "",
            require_min_distance: ""
        }
    );

    const [loadingPage, setLoadingPage] = useState(false);
    const [loadingSave, setLoadingSave] = useState(false);


    useEffect(() => {
        if (initialPreferences) {
            setPreferences(initialPreferences);
        } else {

            setPreferences({
                name: "",
                enabled: 0,
                enable_exit_on_sequential_duties: 0,
                enable_single_entry: 0,
                enable_facial_recognition: 0,
                enable_register_history: 0,
                enable_justify_time: 0,
                enable_register_status_view: 0,
                presence_permission_check_rt: 0,
                require_geolocation: 0,
                show_checkin_button_before: "",
                presence_permission_check_rt_limit: 0,
                show_checkout_button_after: "",
                require_min_distance: ""
            });

            setSelectedDepartments([]);
            setSelectedLocals([]);

        }
    }, [initialPreferences]);

    useEffect(() => {
        if (initialPreferences) {
            if (departments.length > 0) {
                const selectedDept = initialPreferences?.presence_settings_departments?.map((item) => {
                    const match = departments.find((d) => d.id === item.department_id);
                    return match ? {value: match.id, label: match.name} : null;
                }).filter(Boolean);
                setSelectedDepartments(selectedDept);
            }

            if (locals.length > 0) {
                const selectedHosp = initialPreferences?.presence_settings_hospitals?.map((item) => {
                    const match = locals.find((h) => h.id === item.hospital_id);
                    return match ? {value: match.id, label: match.name} : null;
                }).filter(Boolean);
                setSelectedLocals(selectedHosp);
            }
        }
    }, [initialPreferences, departments, locals]);


    useEffect(() => {
        if (show) {
            fetchDepartments();
            fetchHospitals();
        }
    }, [show]);

    const handleSwitchChange = (field) => (value) => {
        setPreferences((prev) => ({
            ...prev,
            [field]: value ? 1 : 0,
        }));
    };

    const handleInputChange = (field) => (e) => {
        setPreferences(prev => ({
            ...prev,
            [field]: e.target.value
        }));
    };

    const fetchDepartments = async () => {
        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/list-department`,
                {all: true, status: 'S'},
                true
            );

            if (response.code === 200) {

                const {data} = ApiService.handleApiResponse(response);

                setDepartments(
                    Array.isArray(data) ? data : []
                );
            } else {
                Swal.fire("Erro", "Erro ao carregar os departamentos.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setDepartments([]);
        }
    };

    const fetchHospitals = async () => {
        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}hospitals/search`,
                {per_page: 300},
                true
            );

            const {data} = ApiService.handleApiResponse(response);

            setLocals(data);

        } catch (error) {
            ApiService.handleApiError(error);
            setLocals([]);
        }
    };


    const handleSave = async () => {
        setLoadingSave(true);
        try {

            const payload = {
                ...preferences,
                show_checkin_button_before: preferences.show_checkin_button_before?.slice(0, 5) || '',
                show_checkout_button_after: preferences.show_checkout_button_after?.slice(0, 5) || '',

                department_id: selectedDepartments?.map((dept) => dept.value),
                hospital_id: selectedLocals?.map((dept) => dept.value),
            };


            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}presence/settings/register`,
                payload,
                true
            );

            if (response.code === 200) {
                Swal.fire("Sucesso", "Preferências salvas com sucesso.", "success")
                    .then(() => onHide(true));
            }

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingSave(false);
        }
    };


    const renderSwitchItem = (label, description, field) => (
        <div className="card border mb-3 p-3">
            <div className="d-flex justify-content-between align-items-start">
                <div>
                    <h6 className="mb-1">{label}</h6>
                    <p className="text-muted mb-0" style={{fontSize: '0.85rem'}}>{description}</p>
                </div>
                <Switch className="me-6" onChange={handleSwitchChange(field)} checked={parseInt(preferences[field]) === 1}
                        onColor="#0d6efd"/>
            </div>
        </div>
    );

    const renderTimeInput = (label, field) => (
        <div className="card border mb-3 p-3">
            <h6 className="mb-1">{label}</h6>
            <input
                type="time"
                className="form-control mt-2 me-6"
                value={preferences[field] || ''}
                onChange={handleInputChange(field)}
            />
        </div>
    );

    return (
        <Modal show={show} onHide={onHide} centered size="lg">
            <Modal.Header closeButton>
                <Modal.Title>{preferences?.id ? "Editar Regra" : "Cadastrar Regra"}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    {loadingPage && <LoadingScreen/>}
                    <Col md={12}>

                        <div className="form-group col-12">
                            <label>Nome da Regra</label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                value={preferences.name || ''} // Exibe apenas números
                                onChange={handleInputChange('name')}
                                placeholder="Nome da Regra"
                                required
                            />
                        </div>


                        {renderSwitchItem("Situação Regra", "Ativar ou desativar a regra.", "enabled")}

                        <hr className="my-3" />
                        <h6 className="text-muted text-uppercase fw-bold mb-3" style={{fontSize: '0.8rem', letterSpacing: '0.05em'}}>Registros de Entrada e Saída</h6>

                        {renderSwitchItem("Solicitar checkin e checkout", "Obrigatório que o plantonista faça check-in ao iniciar um plantão e check-out para finalizar o mesmo.", "require_geolocation")}
                        {renderSwitchItem("Registro de saída em plantões subsequentes", "Permite um único registro de entrada e saída em dois plantões seguidos.", "enable_exit_on_sequential_duties")}
                        {renderSwitchItem("Registro de entrada único", "Impede iniciar um novo plantão se houver outro sem registro de saída.", "enable_single_entry")}
                        {renderSwitchItem("Registro de entrada e saída através de reconhecimento facial", "Permite o uso do sistema de reconhecimento facial no registro.", "enable_facial_recognition")}

                        <hr className="my-3" />
                        <h6 className="text-muted text-uppercase fw-bold mb-3" style={{fontSize: '0.8rem', letterSpacing: '0.05em'}}>Visibilidade e Histórico</h6>

                        {renderSwitchItem("Histórico de registros de entrada e saída", "Profissionais podem visualizar todos os registros feitos.", "enable_register_history")}
                        {renderSwitchItem("Justificar horários de entrada e saída", "Permite justificar registros de entrada e saída.", "enable_justify_time")}
                        {renderSwitchItem("Visualização do status dos registros", "Permite visualizar o status de registros de presença.", "enable_register_status_view")}

                        <hr className="my-3" />
                        <h6 className="text-muted text-uppercase fw-bold mb-3" style={{fontSize: '0.8rem', letterSpacing: '0.05em'}}>Plantões Retroativos</h6>

                        {renderSwitchItem("Plantões data retroativa", "Permitir que o gestor lance plantões retroativos e altere o plantonista de um plantão que já foi finalizado.", "presence_permission_check_rt")}

                        {parseInt(preferences.presence_permission_check_rt) === 1 && (
                            <div className="col-6">
                                <div className="card border mb-3 p-3">
                                    <h6 className="mb-1">Quantidade de dias retroativo</h6>
                                    <input
                                        type="number"
                                        className="form-control mt-2"
                                        value={preferences.presence_permission_check_rt_limit || ''}
                                        onChange={handleInputChange('presence_permission_check_rt_limit')}
                                    />
                                </div>
                            </div>
                        )}

                        <hr className="my-3" />
                        <h6 className="text-muted text-uppercase fw-bold mb-3" style={{fontSize: '0.8rem', letterSpacing: '0.05em'}}>Horários e Distância</h6>

                        <div className="row">
                            <div className="col-4">
                                {renderTimeInput("Início do plantão visível a partir de", "show_checkin_button_before")}
                            </div>
                            <div className="col-4">
                                {renderTimeInput("Término do plantão visível até", "show_checkout_button_after")}
                            </div>
                            <div className="col-4">
                                <div className="card border mb-3 p-3">
                                    <h6 className="mb-1">Distância mínima (metros)</h6>
                                    <input
                                        type="number"
                                        className="form-control mt-2"
                                        value={preferences.require_min_distance || ''}
                                        onChange={handleInputChange('require_min_distance')}
                                    />
                                </div>
                            </div>
                        </div>

                        <hr className="my-3" />
                        <h6 className="text-muted text-uppercase fw-bold mb-3" style={{fontSize: '0.8rem', letterSpacing: '0.05em'}}>Aplicar a</h6>

                        <div className="row">
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Departamentos</label>
                                    <Select
                                        isMulti
                                        options={departments.map((dept) => ({
                                            value: dept.id,
                                            label: dept.name,
                                        }))}
                                        value={selectedDepartments}
                                        onChange={setSelectedDepartments}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Selecionar departamento..."
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({...base, zIndex: 9999}),
                                            menu: base => ({...base, zIndex: 9999}),
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-6">
                                <div className="mb-3">
                                    <label className="form-label fw-semibold">Local</label>
                                    <Select
                                        isMulti
                                        options={locals.map((loc) => ({
                                            value: loc.id,
                                            label: loc.name,
                                        }))}
                                        value={selectedLocals}
                                        onChange={setSelectedLocals}
                                        className="basic-multi-select"
                                        classNamePrefix="select"
                                        placeholder="Selecionar local..."
                                        menuPortalTarget={document.body}
                                        styles={{
                                            menuPortal: base => ({...base, zIndex: 9999}),
                                            menu: base => ({...base, zIndex: 9999}),
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>

                <div className="d-flex justify-content-end mt-3">
                    <button className="btn btn-dark ms-2" type="button" onClick={() => onHide()} disabled={loadingSave}>
                        <i className="fa fa-close"></i> Cancelar
                    </button>
                    <button className="btn btn-info ms-2" type="button" onClick={() => handleSave()}
                            disabled={loadingSave}>
                        {loadingSave ? (
                            <>
                                <span className="spinner-border spinner-border-sm me-2" role="status"
                                      aria-hidden="true"></span>
                                Salvando...
                            </>
                        ) : (
                            <>
                                <i className="fa fa-plus me-2"></i> Salvar
                            </>
                        )}
                    </button>
                </div>
            </Modal.Body>
        </Modal>
    )
        ;
};

export default PreferencesPresenceAttendanceControlModal;
